export default __webpack_public_path__ + "static/media/icon2.4bb38d9c.png";